import { AlertCircle } from "lucide-react";
import { Heading2 } from "../Typography";

interface ErrorStateProps {
  title?: string;
  message: string;
  className?: string;
}

export function ErrorState({ title = "Error", message, className = "" }: ErrorStateProps) {
  return (
    <div
      data-testid="error-state"
      className={`flex flex-col col-span-full items-center justify-center p-4 text-center text-red-600 ${className}`}
    >
      <div className="p-4 inline-flex items-center justify-center">
        <AlertCircle className="h-8 w-8 text-red-600" />
      </div>
      <div className="flex items-center justify-center text-center w-full">
        <Heading2 className="font-medium text-md text-center">{title || "Something went wrong"}</Heading2>
      </div>
      <pre
        className="text-sm text-red-600 text-center w-full break-words whitespace-pre-wrap line-clamp-2"
        title={message}
      >
        {message}
      </pre>
    </div>
  );
}
